import { useState } from 'react'
import { Check, Copy, ExternalLink, X } from 'lucide-react'

export function DeployModal({ url, onClose }: { url: string; onClose: () => void }) {
  const [copied, setCopied] = useState(false)

  async function copy() {
    await navigator.clipboard.writeText(url)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
      <div className="w-full max-w-md rounded-2xl border border-zinc-800 bg-zinc-900 p-6">
        <div className="flex items-start justify-between">
          <h2 className="text-xl font-extrabold text-white">Your page is live 🎉</h2>
          <button onClick={onClose} className="text-zinc-500 hover:text-white">
            <X className="h-5 w-5" />
          </button>
        </div>
        <p className="mt-2 text-sm text-zinc-400">
          Share this link to showcase your startups and grow your audience.
        </p>
        <div className="mt-4 flex items-center gap-2 rounded-lg border border-zinc-700 bg-zinc-950 px-3 py-2.5">
          <span className="flex-1 truncate text-sm text-zinc-200">{url}</span>
          <button onClick={copy} className="text-zinc-400 hover:text-white" aria-label="Copy link">
            {copied ? <Check className="h-4 w-4 text-emerald-400" /> : <Copy className="h-4 w-4" />}
          </button>
        </div>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-fuchsia-500 py-3 text-sm font-bold text-white hover:bg-fuchsia-400"
        >
          View live page <ExternalLink className="h-4 w-4" />
        </a>
      </div>
    </div>
  )
}
